import { render, staticRenderFns } from "./ModalWatchWriting.vue?vue&type=template&id=58224c78&scoped=true"
import script from "./ModalWatchWriting.vue?vue&type=script&lang=js"
export * from "./ModalWatchWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58224c78",
  null
  
)

export default component.exports